export default {
  AvailableStartTimeMin: 'شروع اعتبار از',
  AvailableStartTimeMax: 'شروع اعتبار تا',
  AvailableExpireTimeMin: 'انقضا از',
  AvailableExpireTimeMax: 'انقضا تا',
  Car: 'خودرو',
  Cost: 'هزینه',
  CarPrice: 'هزینه خودرو',
  Commission: 'کمیسیون',
  CommissionPercent: 'درصد کمیسیون',
  CommissionAmount: 'مقدار کمیسیون',
  CompanyDiscountPercent: 'درصد تخفیف پروژه',
  CompanyDiscountAmount: 'مقدار تخفیف پروژه',
  Description: 'توضیحات',
  DateTo: 'تاریخ تا',
  DateFrom: 'تاریخ از',
  ExtraHourCommissionPercent: 'درصد کمیسیون ساعت اضافه',
  ExtraHourCommissionAmount: 'کمیسیون ساعت اضافه',
  ExtraKilometerCommissionPercent: 'درصد کمیسیون کیلومتر اضافه',
  ExtraKilometerCommissionAmount: 'مقدار کمیسیون کیلومتر اضافه',
  ExtraKilometerPrice: 'قیمت کیلومتر اضافه',
  ExtraHourPrice: 'قیمت ساعت اضافه',
  ExtraTariff: 'تعرفه خاص',
  Employee: 'نیروی فنی',
  Laborer: 'کارگر',
  LaborerPrice: 'هزینه کارگر خودرو',
  FreeAmount: 'مقدار رایگان',
  Items: 'اقلام',
  freeCount: 'تعداد طبقات سرویس دهی',
  packSize: 'نرخ اضافه شدن طبقات',
  PledgePercent: 'درصد بیعانه',
  pledge: 'بیعانه',
  PledgeAmount: 'مقدار بیعانه',
  Price: 'قیمت',
  MarketplaceDiscountPercent: 'درصد تخفیف بادپا',
  MarketplaceDiscountAmount: 'مقدار تخفیف بادپا',
  LaborerCommissionPercent: 'درصد کمیسیون کارگر',
  LaborerExtraHourCommissionPercent: 'درصد کمیسیون هر ساعت اضافه کارگر',
  LaborerCompanyDiscountPercent: 'درصد تخفیف پروژه برای کارگر',
  LaborerMarketplaceDiscountPercent: 'درصد تخفیف بادپا برای کارگر',
  ServiceHour: 'زمان سرویس‌دهی',
  ServiceKilometer: 'کیلومتر سرویس‌دهی',
  NonRoundedAmount: 'مقدار گرد نشده',
  TaxAmount: 'هزینه مالیات',
  TollAmount: 'هزینه عوارض',
  TotalAmount: 'مجموع هزینه ها',
  PayableAmount: 'هزینه قابل پرداخت',
  AssignRequired: 'نیازمند تخصیص',
  TariffAuction: 'مزایده',
  Pricing: 'تعیین قیمت',
  RoundTripPercent: 'نرخ اضافه رفت و برگشت',
  PerKilometerPrice: 'هزینه به ازای هر کیلومتر',
  TariffShowAndRecord: 'مشاهده و ثبت تعرفه',
  TrafficPlanShowAndRecord: 'مشاهده و ثبت تعرفه طرح ترافیک',
  ExcessCommissionPercent: 'درصد کمیسیون هزینه مازاد',
  tariffPage: 'صفحه تعرفه',
  tariffDeletedSuccessfully: 'تعرفه با موفقیت حذف شد',
  ExtraKilometerCommission: 'کمیسیون کیلومتر اضافه',
  carDistanceCost: 'هزینه فاصله تا ماشین',
  laborerExtraFloorCost: 'قیمت طبقات اضافی کارگر',
  laborerExtraFloorComission: 'کمیسیون طبقات اضافی کارگر',
  primaryPrice: 'هزینه اولیه',
  perKilometerPrice: 'قیمت کیلومتر اضافه',
  auctionCommission: 'کمیسیون مزایده',
  expired: 'منقضی شده',
  available: 'در دسترس',
  excessCommission: 'کمیسیون هزینه مازاد',
  tariffDetail: 'جزییات تعرفه',
  waitMinutePrice: 'هزینه هر دقیقه توقف',
  driverIncome: 'درآمد راننده',
  courierIncome: 'درآمد پروژه',
  carDistanceFreeCount: 'مقدار فاصله رایگان تا ماشین',
  distanceKilometer: 'هزینه به ازای هر کیلومتر',
  waitMinute: 'هزینه هر دقیقه توقف',
  laborer: 'هزینه کارگر خودرو',
  car: 'هزینه خودرو',
  primary: 'هزینه اولیه',
  specialHour: 'ساعت خاص',
  surchargePrice: 'نرخ اضافه',
  weathers: 'آب و هوا',
  noSpecialTime: 'هیچ بازه زمانی ای وارد نشده است',
  noWeather: 'هیچ آب و هوایی وارد نشده است',
  conflictInSpecialTime: 'در بازه زمانی های انتخابی تداخل وجود دارد',
  addon: 'هزینه خدمات جانبی'
}
